import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Button as MuiButton, createTheme, ThemeProvider, StyledEngineProvider, IconButton as MuiIconButton, useTheme, Tooltip, adaptV4Theme } from '@mui/material';
import deepmerge from 'deepmerge';
import Icon from '../Icon';
import { darkThemeStyles } from '../Theme';
import { designTokens } from '../Theme.design-tokens';
var darkContainedPrimaryTheme = createTheme(adaptV4Theme(deepmerge(darkThemeStyles, {
  palette: {
    primary: {
      main: designTokens.colors.blue500
    }
  }
})));
var darkOutlinedPrimaryTheme = createTheme(adaptV4Theme(deepmerge(darkThemeStyles, {
  palette: {
    primary: {
      main: designTokens.colors.white
    }
  }
})));

var Button = function Button(_ref) {
  var a11yControls = _ref.a11yControls,
      a11yDescribedby = _ref.a11yDescribedby,
      a11yHaspopup = _ref.a11yHaspopup,
      a11yLabel = _ref.a11yLabel,
      body = _ref.body,
      buttonRef = _ref.buttonRef,
      children = _ref.children,
      dsOnClick = _ref.dsOnClick,
      e2e = _ref.e2e,
      fullWidth = _ref.fullWidth,
      disabled = _ref.disabled,
      disableRipple = _ref.disableRipple,
      href = _ref.href,
      startIcon = _ref.startIcon,
      endIcon = _ref.endIcon,
      icon = _ref.icon,
      size = _ref.size,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === void 0 ? '' : _ref$tooltip,
      _ref$disableInteracti = _ref.disableInteractiveTooltip,
      disableInteractiveTooltip = _ref$disableInteracti === void 0 ? false : _ref$disableInteracti,
      type = _ref.type,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'contained' : _ref$variant,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      sx = _ref.sx,
      target = _ref.target;
  var theme = useTheme();

  var defaultButton = function defaultButton() {
    var buttonVariant;
    var className;

    switch (variant) {
      case 'tertiary':
        className = 'tertiary';
        buttonVariant = 'outlined';
        break;

      default:
        buttonVariant = variant;
    }

    return /*#__PURE__*/React.createElement(MuiButton, _extends({
      "aria-controls": a11yControls,
      "aria-describedby": a11yDescribedby || body || tooltip,
      "aria-haspopup": a11yHaspopup,
      variant: buttonVariant,
      color: "primary"
    }, className && {
      className: className
    }, {
      disabled: disabled,
      disableRipple: disableRipple
    }, e2e && {
      'data-e2e': e2e
    }, {
      fullWidth: fullWidth,
      onClick: dsOnClick,
      href: href,
      size: size,
      type: type,
      focusRipple: true,
      startIcon: startIcon && /*#__PURE__*/React.createElement(Icon, {
        color: "inherit",
        body: startIcon
      }),
      endIcon: endIcon && /*#__PURE__*/React.createElement(Icon, {
        color: "inherit",
        body: endIcon
      }),
      ref: buttonRef,
      autoFocus: autoFocus,
      target: target,
      sx: sx
    }), /*#__PURE__*/React.createElement("span", e2e && {
      'data-e2e': "".concat(e2e, "-body")
    }, body, children));
  };

  var iconButton = /*#__PURE__*/React.createElement(MuiIconButton, _extends({
    "aria-label": a11yLabel || tooltip || icon,
    sx: sx,
    disabled: disabled,
    disableRipple: disableRipple
  }, e2e && {
    'data-e2e': e2e
  }, {
    onClick: dsOnClick
  }, href && {
    href: href
  }, {
    size: size,
    ref: buttonRef,
    autoFocus: autoFocus
  }), /*#__PURE__*/React.createElement(Icon, {
    color: "inherit",
    body: icon
  }));
  var button = icon ? iconButton : defaultButton();
  var wrappedButton = tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
    arrow: true,
    title: tooltip,
    PopperProps: _objectSpread(_objectSpread({}, e2e && {
      'data-e2e': "".concat(e2e, "-tooltip")
    }), {}, {
      modifiers: []
    }),
    disableInteractive: disableInteractiveTooltip
  }, /*#__PURE__*/React.createElement("span", null, button)) : button;
  var isDark = theme.palette.mode === 'dark';

  if (isDark && !disabled) {
    switch (variant) {
      case 'contained':
        {
          return /*#__PURE__*/React.createElement(StyledEngineProvider, {
            injectFirst: true
          }, /*#__PURE__*/React.createElement(ThemeProvider, {
            theme: darkContainedPrimaryTheme
          }, wrappedButton));
        }

      default:
        {
          return /*#__PURE__*/React.createElement(StyledEngineProvider, {
            injectFirst: true
          }, /*#__PURE__*/React.createElement(ThemeProvider, {
            theme: darkOutlinedPrimaryTheme
          }, wrappedButton));
        }
    }
  }

  return wrappedButton;
};

Button.defaultProps = {
  variant: 'contained'
};
Button.displayName = 'Button';
export default Button;
//# sourceMappingURL=index.js.map